export const userHandleAccessor = (user) => {
    if (!user) {
        return '';
    }

    return user.handle || user.screen_name;
};
